import { Resources } from '../resource';

export { default as list } from './List';
export const name = Resources.systemProxy;
